import { Layout as AntLayout, Menu } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  DashboardOutlined,
  UserOutlined,
  TeamOutlined,
  LockOutlined,
  AuditOutlined,
} from '@ant-design/icons';
import { useAuthStore } from '@/stores/auth';
import styles from './index.module.css';

const { Header, Sider, Content } = AntLayout;

const menuItems = [
  {
    key: '/',
    icon: <DashboardOutlined />,
    label: '仪表盘',
  },
  {
    key: '/system/users',
    icon: <UserOutlined />,
    label: '系统用户',
  },
  {
    key: '/business/users',
    icon: <TeamOutlined />,
    label: '业务用户',
  },
  {
    key: '/business/permissions',
    icon: <LockOutlined />,
    label: '权限管理',
  },
  {
    key: '/audit-logs',
    icon: <AuditOutlined />,
    label: '审计日志',
  },
];

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuthStore();

  const handleMenuClick = (key: string) => {
    navigate(key);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <AntLayout className={styles.layout}>
      <Sider width={200} theme="light">
        <div className={styles.logo}>DB Manager</div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => handleMenuClick(key)}
        />
      </Sider>
      <AntLayout>
        <Header className={styles.header}>
          <div className={styles.userInfo}>
            <span>管理员</span>
            <a onClick={handleLogout}>退出登录</a>
          </div>
        </Header>
        <Content className={styles.content}>
          <Outlet />
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout; 